"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdtsPixelTracker = void 0;
const EdtsPixelTracker = ({ pixelId }) => {
    (function (f, b, e, v, n, t, s) {
        if (f.fbq)
            return;
        n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq)
            f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    const fbq = window.fbq;
    const init = () => {
        fbq('init', pixelId);
    };
    const createNormalTracker = ({ identity }) => {
        fbq("track", identity);
    };
    const createCustomTracker = ({ identity, addOptions }) => {
        fbq("trackCustom", identity, addOptions);
    };
    return {
        init,
        createNormalTracker,
        createCustomTracker
    };
};
exports.EdtsPixelTracker = EdtsPixelTracker;
